import { AutogenModelSegAllocCode, AutogenRowSegAllocCode } from "./autogen/AutogenModelSegAllocCode";

export class ModelSegAllocCode extends AutogenModelSegAllocCode<RowSegAllocCode> {
	constructor() {
		super(RowSegAllocCode);
	}
}

export class RowSegAllocCode extends AutogenRowSegAllocCode {
}